import { HttpClient, HttpResponse } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'

const API_URL = environment.apiURL

@Injectable({
  providedIn: 'root'
})
export class MessageTapeRepositoryService {

  private httpClient: HttpClient = inject(HttpClient)

  public getPublicationNotice(): Observable<HttpResponse<any>> {
    return this.httpClient.get(`${API_URL}/centralweb/avisopublicacao?$select=ativo,mensagem`, { observe: 'response' })
  }
}
